var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsObject, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
export class TourStatusFullSizeDto {
    id;
    createdAt;
    updatedAt;
    userId;
    user;
    exerciseLibraryTourCompleted;
    officeMgmTourCompleted;
    officeProfileSettingsTourCompleted;
    officeShopTourCompleted;
    videoCallTourCompleted;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TourStatusFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TourStatusFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TourStatusFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TourStatusFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], TourStatusFullSizeDto.prototype, "user", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], TourStatusFullSizeDto.prototype, "exerciseLibraryTourCompleted", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], TourStatusFullSizeDto.prototype, "officeMgmTourCompleted", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], TourStatusFullSizeDto.prototype, "officeProfileSettingsTourCompleted", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], TourStatusFullSizeDto.prototype, "officeShopTourCompleted", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], TourStatusFullSizeDto.prototype, "videoCallTourCompleted", void 0);
//# sourceMappingURL=tour-status.full-size.dto.js.map